"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2293],{

/***/ 85026:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ Tab; },
/* harmony export */   "m": function() { return /* binding */ Tabs; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _Box__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51773);


const Tab = (param)=>{
    let { children , title  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: children
    });
};
const Tabs = (param)=>{
    let { activeTitle , children , stickyHeader =false , className  } = param;
    const activeTab = children.filter((c)=>c !== false).find((c)=>c.props.title === activeTitle);
    if (className) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
        className: className,
        children: activeTab
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: activeTab
    });
};


/***/ }),

/***/ 82316:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12451);
/* harmony import */ var _libs_useTheme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5779);




const linkVariants = {
    hover: {
        scale: 1.05
    }
};
const TextLink = (param)=>{
    let { children , className , style , ignoreTheme =false  } = param;
    const { theme  } = (0,_libs_useTheme__WEBPACK_IMPORTED_MODULE_2__/* .useTheme */ .Fg)();
    const isUrl = (word)=>{
        const urlPattern = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|])/gi;
        return urlPattern.test(word);
    };
    const processText = (text)=>{
        return text.split(/\n/).map((line, index)=>{
            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                style: {
                    whiteSpace: "pre-wrap",
                    margin: 0
                },
                children: line.split(" ").map((word, index)=>{
                    if (isUrl(word)) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_3__/* .motion.a */ .E.a, {
                            href: word,
                            target: "_blank",
                            rel: "noopener noreferrer",
                            style: ignoreTheme ? {} : {
                                color: theme === null || theme === void 0 ? void 0 : theme.textColour
                            },
                            className: "text-blue-500 underline break-words",
                            variants: linkVariants,
                            whileHover: "hover",
                            children: word
                        }, index);
                    }
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                        className: "break-words",
                        children: [
                            word,
                            " "
                        ]
                    }, index);
                })
            }, index);
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: className,
        style: {
            ...!ignoreTheme && {
                color: theme === null || theme === void 0 ? void 0 : theme.textColour
            },
            ...style
        },
        children: typeof children === "string" ? processText(children) : children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TextLink);


/***/ }),

/***/ 62293:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ EventChatBox; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var node_modules_react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-icons/md/index.esm.js
var index_esm = __webpack_require__(5434);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useMutation.js + 1 modules
var useMutation = __webpack_require__(72742);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useQuery.js + 2 modules
var useQuery = __webpack_require__(6812);
// EXTERNAL MODULE: ./graphql/__generated/index.ts + 1 modules
var _generated = __webpack_require__(66703);
;// CONCATENATED MODULE: ./graphql/messages/createMessageForChatId.ts

const CREATE_MESSAGE_FOR_CHAT_ID = (0,_generated/* graphql */.B)("\n  mutation CreateMessageForChatId($input: CreateMessageInput!) {\n    createMessageForChatId(input: $input) {\n      ...MessageFull\n    }\n  }\n");

;// CONCATENATED MODULE: ./graphql/messages/getMessagesForChatId.ts

const GET_MESSAGES_FOR_CHAT_ID = (0,_generated/* graphql */.B)("\n  query GetMessagesForChatId($input: GetMessagesForChatId!) {\n    getMessagesForChatId(input: $input) {\n      ...MessageFull\n    }\n  }\n");

;// CONCATENATED MODULE: ./graphql/messages/messageChanged.ts

const MESSAGE_CHANGED = (0,_generated/* graphql */.B)("\n  subscription MessageChanged($input: String!) {\n    messageChanged(chatId: $input) {\n      ...MessageFull\n    }\n  }\n");

// EXTERNAL MODULE: ./components/inputs/TextAreaInput.tsx
var TextAreaInput = __webpack_require__(33923);
// EXTERNAL MODULE: ./node_modules/react-icons/bs/index.esm.js
var bs_index_esm = __webpack_require__(63750);
// EXTERNAL MODULE: ./libs/useAuth.ts + 25 modules
var useAuth = __webpack_require__(97358);
;// CONCATENATED MODULE: ./graphql/messages/reactToMessage.ts

const REACT_TO_MESSAGE = (0,_generated/* graphql */.B)("\n  mutation ReactToMessage(\n    $emoji: String!\n    $messageUserId: String!\n    $chatId: String!\n    $messageId: String!\n  ) {\n    reactToMessage(\n      emoji: $emoji\n      messageUserId: $messageUserId\n      chatId: $chatId\n      messageId: $messageId\n    ) {\n      ...MessageFull\n    }\n  }\n");

// EXTERNAL MODULE: ./node_modules/emoji-picker-react/dist/emoji-picker-react.esm.js
var emoji_picker_react_esm = __webpack_require__(63048);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./node_modules/react-icons/bi/index.esm.js
var bi_index_esm = __webpack_require__(47516);
// EXTERNAL MODULE: ./components/base/Text.tsx
var Text = __webpack_require__(40517);
// EXTERNAL MODULE: ./libs/useTheme.ts + 1 modules
var useTheme = __webpack_require__(5779);
// EXTERNAL MODULE: ./components/base/Box.tsx
var Box = __webpack_require__(51773);
// EXTERNAL MODULE: ./libs/useChat.ts
var useChat = __webpack_require__(23687);
// EXTERNAL MODULE: ./libs/useEvent.ts
var useEvent = __webpack_require__(39099);
// EXTERNAL MODULE: ./components/base/ProfileImage.tsx
var ProfileImage = __webpack_require__(19527);
// EXTERNAL MODULE: ./components/base/TextLink.tsx
var TextLink = __webpack_require__(82316);
;// CONCATENATED MODULE: ./components/chat/MessageWrapper.tsx















const MessageWrapper = (param)=>{
    let { message , children  } = param;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    const [showPicker, setShowPicker] = (0,node_modules_react.useState)(false);
    const [showEmojiPicker, setShowEmojiPicker] = (0,node_modules_react.useState)(false);
    const containerRef = (0,node_modules_react.useRef)(null);
    const emojiPickerRef = (0,node_modules_react.useRef)(null);
    const [react] = (0,useMutation/* useMutation */.D)(REACT_TO_MESSAGE);
    const { profile  } = (0,useAuth/* useAuth */.aC)();
    const { theme  } = (0,useTheme/* useTheme */.Fg)();
    const { setModalUser  } = (0,useChat/* useChat */.R)();
    const { event  } = (0,useEvent/* useEvent */.z)();
    const handleClickOutside = (e)=>{
        var ref;
        if (!(containerRef === null || containerRef === void 0 ? void 0 : (ref = containerRef.current) === null || ref === void 0 ? void 0 : ref.contains(e.target))) {
            setShowEmojiPicker(false);
            setShowPicker(false);
        }
    };
    var ref7, ref8;
    const speakers = (ref8 = ((ref7 = event === null || event === void 0 ? void 0 : event.speakers) !== null && ref7 !== void 0 ? ref7 : []).map((user)=>user.email)) !== null && ref8 !== void 0 ? ref8 : [];
    const isSpeaker = speakers.indexOf(message === null || message === void 0 ? void 0 : (ref = message.user) === null || ref === void 0 ? void 0 : ref.email) > -1;
    (0,node_modules_react.useEffect)(()=>{
        if (showEmojiPicker) {
            var ref;
            document.addEventListener("mousedown", handleClickOutside);
            (ref = emojiPickerRef.current) === null || ref === void 0 ? void 0 : ref.scrollIntoView();
        }
        return ()=>document.removeEventListener("mousedown", handleClickOutside);
    }, [
        showEmojiPicker
    ]);
    var ref9;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
        className: "flex flex-row relative hover:bg-gray-100 transition-all rounded-md gap-3 p-2 m-1 ml-2 mr-2",
        innerRef: containerRef,
        onMouseEnter: ()=>setShowPicker(true),
        onMouseLeave: ()=>setShowPicker(false),
        children: [
            showEmojiPicker && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                innerRef: emojiPickerRef,
                className: "absolute right-[16px] top-[20px] z-50 pb-16",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(emoji_picker_react_esm/* default */.ZP, {
                    previewConfig: {
                        showPreview: false
                    },
                    height: 300,
                    theme: emoji_picker_react_esm/* Theme.DARK */.Q2.DARK,
                    onEmojiClick: async (emoji)=>{
                        setShowEmojiPicker(false);
                        setShowPicker(false);
                        await react({
                            variables: {
                                emoji: emoji.emoji,
                                chatId: message.chatId,
                                messageId: message.messageId,
                                messageUserId: message.user.userId
                            }
                        });
                    }
                })
            }),
            (showPicker || showEmojiPicker) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                className: "shadow-md hover:shadow-lg border-gray-400 hover:border-gray-600 transition-all flex items-center rounded-md border border-solid border-gray-900 absolute top-[-16px] right-[16px] text-white",
                style: {
                    backgroundColor: theme.foregroundColour
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: "h-[32px] w-[32px] flex items-center justify-center text-neutral-content border-solid border-gray-900 transition-all relative",
                        "aria-expanded": "false",
                        onClick: ()=>setShowEmojiPicker(!showEmojiPicker),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(bi_index_esm/* BiSmile */.HTX, {
                            fill: theme.textColour,
                            className: "w-full h-full p-2 left-0"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: "h-[32px] w-[32px] flex items-center justify-center text-neutral-content border-solid border-gray-900 transition-all hidden",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(bi_index_esm/* BiReply */.S1G, {
                            className: "w-full h-full p-2"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileImage/* default */.Z, {
                    imageUrl: message === null || message === void 0 ? void 0 : (ref1 = message.user) === null || ref1 === void 0 ? void 0 : ref1.profileImage,
                    size: "md",
                    onClick: ()=>{
                        return setModalUser === null || setModalUser === void 0 ? void 0 : setModalUser(message.user);
                    },
                    activityStatus: (message === null || message === void 0 ? void 0 : (ref2 = message.user) === null || ref2 === void 0 ? void 0 : ref2.isAnonymous) === "true" ? false : message === null || message === void 0 ? void 0 : (ref3 = message.user) === null || ref3 === void 0 ? void 0 : ref3.isActive
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                className: "flex flex-col overflow-x-auto",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                        className: "flex w-full ",
                        onClick: ()=>{
                            return setModalUser === null || setModalUser === void 0 ? void 0 : setModalUser(message === null || message === void 0 ? void 0 : message.user);
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                className: "text-white text-sm font-bold cursor-pointer",
                                children: [
                                    message === null || message === void 0 ? void 0 : (ref4 = message.user) === null || ref4 === void 0 ? void 0 : ref4.name,
                                    isSpeaker ? " (Speaker)" : ""
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-gray-400 text-xs ml-3 mt-[2px] cursor-pointer ",
                                children: moment_default()(message.dateCreated).calendar()
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                        className: "flex flex-col overflow-x-auto gap-1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextLink/* default */.Z, {
                                ignoreTheme: true,
                                className: "relative w-full text-sm overflow-x-auto",
                                children: message === null || message === void 0 ? void 0 : message.message
                            }),
                            children,
                            ((ref9 = message === null || message === void 0 ? void 0 : (ref5 = message.reactions) === null || ref5 === void 0 ? void 0 : ref5.length) !== null && ref9 !== void 0 ? ref9 : 0) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                className: "flex flex-wrap",
                                children: (ref6 = message.reactions) === null || ref6 === void 0 ? void 0 : ref6.map((r)=>{
                                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(Box["default"], {
                                        className: "h-8 px-2 text-sm flex items-center rounded-md border border-solid border-gray-400 hover:border-gray-600 cursor-pointer border-opacity-70 transition-all relative space-x-2 mr-1 hover:shadow-md",
                                        style: {
                                            backgroundColor: r.users.find((u)=>{
                                                return u.userId === (profile === null || profile === void 0 ? void 0 : profile.userId);
                                            }) ? theme.foregroundColour : theme.backgroundColour,
                                            color: theme.textColour
                                        },
                                        onClick: async ()=>{
                                            await react({
                                                variables: {
                                                    emoji: r.emoji,
                                                    chatId: message.chatId,
                                                    messageId: message.messageId,
                                                    messageUserId: message.user.userId
                                                }
                                            });
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: r.emoji
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: r.users.length
                                            })
                                        ]
                                    }, r.emoji);
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/chat/MessageView.tsx





const MessageView = (param)=>{
    let { message  } = param;
    const { profile  } = (0,useAuth/* useAuth */.aC)();
    const { setModalUser  } = (0,useChat/* useChat */.R)();
    const { theme  } = (0,useTheme/* useTheme */.Fg)();
    const isLight = theme.type === "LIGHT";
    const textColor = isLight ? "white" : theme.textColour;
    if (message.message && message.message.startsWith("https://app.sli.do/event/")) {
        const slidoId = message.message.split("https://app.sli.do/event/").at(-1);
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(MessageWrapper, {
            message: message,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                src: "https://app.sli.do/event/".concat(slidoId),
                height: "85%",
                width: "100%",
                style: {
                    minHeight: 520
                },
                title: "Slido",
                className: "rounded-xl"
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MessageWrapper, {
        message: message
    });
};

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
;// CONCATENATED MODULE: ./components/chat/ChatBox.tsx












const MessageInput = (param)=>{
    let { chatId  } = param;
    const [sendMessage] = (0,useMutation/* useMutation */.D)(CREATE_MESSAGE_FOR_CHAT_ID);
    const [message, setMessage] = (0,node_modules_react.useState)("");
    const { theme  } = (0,useTheme/* useTheme */.Fg)();
    const isDarkTheme = theme.type === "DARK";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
        className: "flex w-full p-3 space-x-1 items-center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextAreaInput/* TextAreaInput */.F, {
                className: "flex-1 mt-0",
                border: "border-none",
                placeholder: "Type to write a message...",
                label: undefined,
                value: message,
                onChange: (e)=>setMessage(e),
                onKeyDown: (e)=>{
                    if (e.key === "Enter") {
                        if (e.shiftKey) {
                            return;
                        }
                        e.preventDefault();
                        if (message.trim() !== "") {
                            sendMessage({
                                variables: {
                                    input: {
                                        chatId: chatId,
                                        message: message
                                    }
                                }
                            });
                            setMessage("");
                        }
                    }
                },
                dynamicResize: true,
                rows: 1,
                preventResize: true,
                preventBorder: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(bs_index_esm/* BsArrowRightShort */.UE1, {
                    className: "text-2xl cursor-pointer ".concat(isDarkTheme ? "text-white" : "text-black"),
                    onClick: ()=>{
                        if (message.trim() !== "") {
                            sendMessage({
                                variables: {
                                    input: {
                                        chatId: chatId,
                                        message: message
                                    }
                                }
                            });
                            setMessage("");
                        }
                    }
                })
            })
        ]
    });
};
const ChatBox = (param)=>{
    let { chatId  } = param;
    const messagesView = (0,node_modules_react.useRef)(null);
    const { data , subscribeToMore , loading  } = (0,useQuery/* useQuery */.a)(GET_MESSAGES_FOR_CHAT_ID, {
        variables: {
            input: {
                chatId
            }
        },
        fetchPolicy: "cache-and-network",
        skip: !chatId
    });
    const scrollToBottom = ()=>{
        var ref;
        (ref = messagesView.current) === null || ref === void 0 ? void 0 : ref.scroll({
            top: messagesView.current.scrollHeight,
            behavior: "smooth"
        });
    };
    (0,node_modules_react.useEffect)(()=>{
        const unsubscribe = subscribeToMore({
            document: MESSAGE_CHANGED,
            variables: {
                input: chatId
            },
            updateQuery: (prev, param)=>{
                let { subscriptionData  } = param;
                const newMessage = subscriptionData.data.messageChanged;
                const newMessages = (0,lodash.isArray)(prev === null || prev === void 0 ? void 0 : prev.getMessagesForChatId) ? [
                    ...prev.getMessagesForChatId
                ] : [];
                const foundIndex = newMessages.findIndex((m)=>m.messageId === newMessage.messageId);
                if (foundIndex === -1) {
                    newMessages.push(newMessage);
                    setTimeout(()=>{
                        scrollToBottom();
                    }, 100);
                } else {
                    newMessages[foundIndex] = newMessage;
                }
                return {
                    getMessagesForChatId: newMessages
                };
            }
        });
        return ()=>unsubscribe();
    }, [
        chatId,
        subscribeToMore
    ]);
    (0,node_modules_react.useEffect)(()=>{
        if (!loading) {
            scrollToBottom();
        }
    }, [
        loading,
        data
    ]);
    const messages = data === null || data === void 0 ? void 0 : data.getMessagesForChatId;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
        className: "relative w-full h-full flex flex-col",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                className: "flex-1 flex flex-col overflow-y-auto pt-4 pb-2",
                innerRef: messagesView,
                loading: loading && messages == null,
                children: messages === null || messages === void 0 ? void 0 : messages.map((m)=>{
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(MessageView, {
                        message: m
                    }, m === null || m === void 0 ? void 0 : m.messageId);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                className: "border-t border-gray-300"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                className: "flex-end w-full",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MessageInput, {
                    chatId: chatId
                })
            })
        ]
    });
};
/* harmony default export */ var chat_ChatBox = (ChatBox);

// EXTERNAL MODULE: ./components/base/Tabs.tsx
var Tabs = __webpack_require__(85026);
// EXTERNAL MODULE: ./components/base/LoadingSpinner.tsx + 1 modules
var LoadingSpinner = __webpack_require__(38999);
// EXTERNAL MODULE: ./components/inputs/Button.tsx
var Button = __webpack_require__(11390);
;// CONCATENATED MODULE: ./graphql/users/getUsersByUniversity.ts

const GET_USERS_IN_COMPANY = (0,_generated/* graphql */.B)("\n  query GetUsersInCompany($company: String!) {\n    getUsersInCompany(company: $company) {\n      total\n      items {\n        ...UserFull\n      }\n    }\n  }\n");

;// CONCATENATED MODULE: ./graphql/users/getUsersInEvent.ts

const GET_USERS_IN_EVENT = (0,_generated/* graphql */.B)("\n  query GetUsersInEvent($input: String!) {\n    getUsersInEvent(input: $input) {\n      items {\n        ...UserFull\n      }\n      total\n    }\n  }\n");

;// CONCATENATED MODULE: ./components/chat/EventPeopleTab.tsx













const EventPeopleTab = (param)=>{
    let { universityUsers =false  } = param;
    const { event  } = (0,useEvent/* useEvent */.z)();
    const { setModalUser  } = (0,useChat/* useChat */.R)();
    const { profile  } = (0,useAuth/* useAuth */.aC)();
    const [users, setUsers] = (0,node_modules_react.useState)([]);
    const { data , loading , refetch  } = (0,useQuery/* useQuery */.a)(GET_USERS_IN_EVENT, {
        variables: {
            input: event === null || event === void 0 ? void 0 : event.eventId
        },
        fetchPolicy: "network-only",
        skip: universityUsers,
        notifyOnNetworkStatusChange: true
    });
    var ref, ref1;
    const { data: grpUsers , loading: grpLoading , refetch: grpRefetch  } = (0,useQuery/* useQuery */.a)(GET_USERS_IN_COMPANY, {
        variables: {
            company: (ref1 = (ref = profile === null || profile === void 0 ? void 0 : profile.university) !== null && ref !== void 0 ? ref : profile === null || profile === void 0 ? void 0 : profile.company) !== null && ref1 !== void 0 ? ref1 : ""
        },
        fetchPolicy: "network-only",
        skip: universityUsers === false,
        notifyOnNetworkStatusChange: true
    });
    (0,node_modules_react.useEffect)(()=>{
        let allUsers = universityUsers ? (grpUsers === null || grpUsers === void 0 ? void 0 : grpUsers.getUsersInCompany.items) || [] : (data === null || data === void 0 ? void 0 : data.getUsersInEvent.items) || [];
        const sortedUsers = [
            ...allUsers
        ].sort((a, b)=>(a.name || "").localeCompare(b.name || ""));
        setUsers(sortedUsers);
    }, [
        grpUsers === null || grpUsers === void 0 ? void 0 : grpUsers.getUsersInCompany,
        data === null || data === void 0 ? void 0 : data.getUsersInEvent,
        universityUsers
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
        className: "text-white flex flex-col space-y-2 p-2 flex-shrink overflow-y-auto",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                iconColor: "white",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MdOutlineRefresh */.Ffb, {}),
                iconPos: "end",
                title: "Refresh",
                loading: universityUsers ? grpLoading && !!grpUsers : loading && !!data,
                className: "flex items-center p-2 cursor-pointer",
                onClick: ()=>{
                    if (universityUsers) grpRefetch();
                    if (!universityUsers) refetch();
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                className: "flex justify-center",
                children: (grpLoading && !grpUsers || loading && !data) && /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingSpinner/* default */.Z, {})
            }),
            users.map((u)=>{
                /*#__PURE__*/ return (0,jsx_runtime.jsxs)(Box["default"], {
                    className: "flex items-center p-2 cursor-pointer hover:bg-gray-100 rounded-md",
                    onClick: ()=>{
                        return setModalUser === null || setModalUser === void 0 ? void 0 : setModalUser(u);
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileImage/* default */.Z, {
                            imageUrl: u.profileImage,
                            size: "md",
                            activityStatus: u.isAnonymous === "true" ? false : u.isActive,
                            className: "w-10 h-10 mr-4"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                    className: "text-white text-sm font-bold",
                                    children: u.name
                                }),
                                u.userId === (event === null || event === void 0 ? void 0 : event.organizerId) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                    className: "bg-blue-500 rounded-xl text-xs inline-block p-1 px-2",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("text", {
                                        className: "text-white",
                                        children: "Organiser"
                                    })
                                })
                            ]
                        })
                    ]
                }, u.userId);
            })
        ]
    });
};
/* harmony default export */ var chat_EventPeopleTab = (EventPeopleTab);

;// CONCATENATED MODULE: ./graphql/messages/getChats.ts

const GET_CHATS = (0,_generated/* graphql */.B)("\n  query GetChats {\n    getChats {\n      chatId\n      lastMessage\n      dateCreated\n      user {\n        ...UserFull\n      }\n    }\n  }\n");

;// CONCATENATED MODULE: ./components/chat/MessagesTab.tsx













const MessagesTab = ()=>{
    const { event  } = (0,useEvent/* useEvent */.z)();
    const { setModalUser , dmChat , setDmChat  } = (0,useChat/* useChat */.R)();
    const { data  } = (0,useQuery/* useQuery */.a)(GET_USERS_IN_EVENT, {
        variables: {
            input: event === null || event === void 0 ? void 0 : event.eventId
        },
        fetchPolicy: "cache-and-network"
    });
    const { data: chatsData , refetch  } = (0,useQuery/* useQuery */.a)(GET_CHATS);
    const allUsers = data === null || data === void 0 ? void 0 : data.getUsersInEvent.items;
    const allChats = chatsData === null || chatsData === void 0 ? void 0 : chatsData.getChats;
    (0,node_modules_react.useEffect)(()=>{
        if (!dmChat) {
            refetch();
        }
    }, [
        refetch,
        dmChat
    ]);
    if (dmChat) {
        var ref, ref1, ref2, ref3, ref4;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
            className: "flex flex-col h-full",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                    className: "text-white border-b-midnight-sky border-b p-4 flex items-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MdArrowBackIos */.rpj, {
                            className: "mr-2 w-5 h-5 cursor-pointer",
                            onClick: ()=>{
                                return setDmChat === null || setDmChat === void 0 ? void 0 : setDmChat(undefined);
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileImage/* default */.Z, {
                            activityStatus: (dmChat === null || dmChat === void 0 ? void 0 : (ref = dmChat.user) === null || ref === void 0 ? void 0 : ref.isAnonymous) === "true" ? false : dmChat === null || dmChat === void 0 ? void 0 : (ref1 = dmChat.user) === null || ref1 === void 0 ? void 0 : ref1.isActive,
                            imageUrl: dmChat === null || dmChat === void 0 ? void 0 : (ref2 = dmChat.user) === null || ref2 === void 0 ? void 0 : ref2.profileImage,
                            className: "cursor-pointer mr-4"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                    children: dmChat === null || dmChat === void 0 ? void 0 : (ref3 = dmChat.user) === null || ref3 === void 0 ? void 0 : ref3.name
                                }),
                                (dmChat === null || dmChat === void 0 ? void 0 : (ref4 = dmChat.user) === null || ref4 === void 0 ? void 0 : ref4.userId) === (event === null || event === void 0 ? void 0 : event.organizerId) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                    className: "bg-blue-500 rounded-xl text-xs inline-block p-1 px-2",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("text", {
                                        className: "text-white",
                                        children: "Organizer"
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                    className: "flex-1 overflow-y-auto",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chat_ChatBox, {
                        chatId: dmChat === null || dmChat === void 0 ? void 0 : dmChat.chatId
                    })
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
        className: "text-white flex flex-col space-y-2 p-2 ",
        children: [
            (allChats === null || allChats === void 0 ? void 0 : allChats.length) === 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                        className: "text-center mt-[20px] text-xl",
                        children: "No direct messages yet!"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                        className: "flex flex-col items-center justify-center mt-[20px] gap-[5px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                className: "text-gray-400 text-s whitespace-nowrap inline-block",
                                children: "To start a conversation, click on the"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                className: "flex items-center gap-[5px]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MdPeople */.J8I, {
                                        className: "w-5 h-5 inline-block"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                        className: "text-gray-400 text-s whitespace-nowrap",
                                        children: "tab and choose a participant."
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            allChats === null || allChats === void 0 ? void 0 : allChats.map((c, index)=>{
                var ref, ref1, ref2, ref3, ref4;
                /*#__PURE__*/ return (0,jsx_runtime.jsx)(node_modules_react.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                        className: "flex items-center p-2 cursor-pointer relative hover:bg-gray-100 transition-all pl-4 pt-1 rounded-md",
                        onClick: ()=>{
                            return setDmChat === null || setDmChat === void 0 ? void 0 : setDmChat({
                                chatId: c.chatId,
                                user: c.user
                            });
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileImage/* default */.Z, {
                                activityStatus: (c === null || c === void 0 ? void 0 : (ref = c.user) === null || ref === void 0 ? void 0 : ref.isAnonymous) === "true" ? false : c === null || c === void 0 ? void 0 : (ref1 = c.user) === null || ref1 === void 0 ? void 0 : ref1.isActive,
                                imageUrl: c === null || c === void 0 ? void 0 : (ref2 = c.user) === null || ref2 === void 0 ? void 0 : ref2.profileImage,
                                size: "md"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                className: "ml-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                        className: "text-white text-sm font-bold",
                                        children: c === null || c === void 0 ? void 0 : (ref3 = c.user) === null || ref3 === void 0 ? void 0 : ref3.name
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                        className: "text-sm text-gray-400 truncate w-64",
                                        children: c === null || c === void 0 ? void 0 : c.lastMessage
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                className: "text-xs absolute right-0 top-0 p-2",
                                children: moment_default()(c === null || c === void 0 ? void 0 : c.dateCreated).format("ddd hh:mm")
                            })
                        ]
                    })
                }, c === null || c === void 0 ? void 0 : (ref4 = c.user) === null || ref4 === void 0 ? void 0 : ref4.userId);
            })
        ]
    });
};
/* harmony default export */ var chat_MessagesTab = (MessagesTab);

;// CONCATENATED MODULE: ./components/chat/EventChatBox.tsx











function EventChatBox(param) {
    let { showEventPeopleTab =true , defaultChatName , defaultChatId , showUniversityUsers =false  } = param;
    const [open, setOpen] = (0,node_modules_react.useState)(false);
    const { event  } = (0,useEvent/* useEvent */.z)();
    const { theme  } = (0,useTheme/* useTheme */.Fg)();
    const { eventChats , chatTab , setChatTab , showDefaultChat  } = (0,useChat/* useChat */.R)();
    const allChats = !!showDefaultChat ? [
        {
            chatId: defaultChatId,
            title: defaultChatName
        },
        ...eventChats
    ] : [
        ...eventChats
    ];
    const [currentChatId, setCurrentChatId] = (0,node_modules_react.useState)(event === null || event === void 0 ? void 0 : event.eventId);
    (0,node_modules_react.useEffect)(()=>{
        if (currentChatId == undefined && (event === null || event === void 0 ? void 0 : event.eventId)) {
            setCurrentChatId(event.eventId);
        } else if (currentChatId !== defaultChatId && (event === null || event === void 0 ? void 0 : event.eventId) == null) {
            setCurrentChatId(defaultChatId);
        }
    }, [
        currentChatId,
        defaultChatId,
        event === null || event === void 0 ? void 0 : event.eventId
    ]);
    (0,node_modules_react.useEffect)(()=>{
        // Tab Switching Logic
        if (eventChats.length >= 1) {
            var ref;
            setCurrentChatId((ref = eventChats.at(-1)) === null || ref === void 0 ? void 0 : ref.chatId);
        } else if (currentChatId && eventChats.map((c)=>c.chatId).includes(currentChatId) === false) {
            setCurrentChatId(event === null || event === void 0 ? void 0 : event.eventId);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        event === null || event === void 0 ? void 0 : event.eventId,
        eventChats
    ]);
    (0,node_modules_react.useEffect)(()=>{
        const toggleChatbox = ()=>{
            setOpen(!open);
        };
        document.addEventListener("toggle-chatbox", toggleChatbox);
        return ()=>{
            document.removeEventListener("toggle-chatbox", toggleChatbox);
        };
    }, [
        open
    ]);
    var _chatId;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
        className: "".concat(open ? " w-1/2 sm:w-1/3 min-w-full sm:min-w-[400px] max-w-[500px]" : "w-0", " border-l border-panel-gray transition-all flex flex-col overflow-x-hidden h-[calc(100vh_-_81px)]"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                className: "flex justify-evenly items-center border-b border-panel-gray text-center",
                children: [
                    allChats.map((o, i)=>{
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(Box["default"], {
                            className: "text-md font-medium py-4 flex-1 cursor-pointer select-none whitespace-nowrap",
                            style: {
                                backgroundColor: o.chatId === currentChatId && chatTab === "Chat" ? theme === null || theme === void 0 ? void 0 : theme.highlightColour : theme.backgroundColour,
                                color: o.chatId === currentChatId && chatTab === "Chat" ? "white" : theme.textColour
                            },
                            onClick: ()=>{
                                setCurrentChatId(o.chatId);
                                setChatTab === null || setChatTab === void 0 ? void 0 : setChatTab("Chat");
                            },
                            children: o.title
                        }, (_chatId = o.chatId) !== null && _chatId !== void 0 ? _chatId : i);
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                        className: "text-white text-sm py-4 px-6 cursor-pointer select-none flex items-center space-x-2 justify-center",
                        style: {
                            backgroundColor: chatTab === "Messages" ? theme === null || theme === void 0 ? void 0 : theme.highlightColour : theme.backgroundColour
                        },
                        onClick: ()=>{
                            setChatTab === null || setChatTab === void 0 ? void 0 : setChatTab("Messages");
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MdMessage */.a9O, {
                            fill: chatTab !== "Messages" ? theme.textColour : theme.type === "DARK" ? theme.textColour : theme.backgroundColour,
                            className: "w-5 h-6"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                        show: showEventPeopleTab,
                        className: "text-white text-sm py-4 px-6 cursor-pointer select-none flex items-center space-x-2 justify-center",
                        style: {
                            backgroundColor: chatTab === "People" ? theme === null || theme === void 0 ? void 0 : theme.highlightColour : theme.backgroundColour
                        },
                        onClick: ()=>{
                            setChatTab === null || setChatTab === void 0 ? void 0 : setChatTab("People");
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MdPeople */.J8I, {
                            fill: chatTab !== "People" ? theme.textColour : theme.type === "DARK" ? theme.textColour : theme.backgroundColour,
                            className: "w-5 h-6"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                className: "flex flex-col h-full overflow-y-auto",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tabs/* Tabs */.m, {
                    activeTitle: chatTab !== null && chatTab !== void 0 ? chatTab : "Chat",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs/* Tab */.O, {
                            title: "Chat",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chat_ChatBox, {
                                chatId: currentChatId
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs/* Tab */.O, {
                            title: "Messages",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chat_MessagesTab, {})
                        }),
                        showEventPeopleTab && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs/* Tab */.O, {
                            title: "People",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chat_EventPeopleTab, {
                                universityUsers: showUniversityUsers
                            })
                        })
                    ]
                })
            })
        ]
    });
}


/***/ }),

/***/ 33923:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ TextAreaInput; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_base_Box__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51773);
/* harmony import */ var _libs_useTheme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5779);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _Validations__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6686);





/**
 * Primary UI component for text input
 */ const TextAreaInput = (param)=>{
    let { label , placeholder , value ="" , onChange , onKeyDown , className , rows , hint , validations , required , testid , show =true , labelBgColour , preventBorder =false , dynamicResize =false , preventResize =false  } = param;
    const errorMessage = (0,_Validations__WEBPACK_IMPORTED_MODULE_4__/* .validate */ .G)(value, validations);
    const ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(null);
    const { theme  } = (0,_libs_useTheme__WEBPACK_IMPORTED_MODULE_2__/* .useTheme */ .Fg)();
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(()=>{
        onLoad();
    }, []);
    const onLoad = ()=>{
        if (!show) return;
        handleDynamicResize();
    };
    if (!show) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    if (value === null) value = "";
    function handleDynamicResize(e) {
        if (dynamicResize && ref.current) {
            ref.current.style.height = "auto";
            ref.current.style.height = ref.current.scrollHeight + "px";
        }
    }
    function handleKeyDown(e) {
        onKeyDown && onKeyDown(e);
        if (e.isDefaultPrevented() && ref.current) ref.current.style.height = "auto";
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
        className: [
            "flex flex-col",
            className
        ].join(" "),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "absolute text-sm -translate-y-1/2 mb-2 ml-2 ".concat(required ? "pl-2" : "px-2", " transition-all ").concat(errorMessage ? "text-red-500" : ""),
                style: {
                    backgroundColor: labelBgColour ? labelBgColour : theme.backgroundColour
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: required ? "after:content-['*'] after:mx-2 after:text-red-500" : "",
                    children: label
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("textarea", {
                required: required,
                value: value,
                onChange: (e)=>{
                    const isInvalid = (0,_Validations__WEBPACK_IMPORTED_MODULE_4__/* .validate */ .G)(e.target.value, validations) !== "";
                    onChange && onChange(e.target.value, isInvalid);
                    handleDynamicResize(e);
                },
                rows: rows !== null && rows !== void 0 ? rows : 3,
                autoComplete: "on",
                placeholder: placeholder,
                className: "transition-all bg-transparent ".concat(preventBorder ? "" : "border", " ").concat(errorMessage ? "text-red-500 border-red-500" : "", " ").concat(preventResize ? "resize-none" : "", " rounded px-4 py-4 text-sm outline-none"),
                "data-testid": testid !== null && testid !== void 0 ? testid : null,
                onKeyDown: handleKeyDown,
                ref: ref
            }),
            hint && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "mt-1 mb-4 ml-2 text-xs",
                children: hint
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                ignoreTheme: true,
                className: "transition-all ".concat(errorMessage ? "opacity-100" : "opacity-0", " text-red-500 text-sm font-bold"),
                children: errorMessage !== null && errorMessage !== void 0 ? errorMessage : "-"
            })
        ]
    });
};


/***/ })

}]);